import { render } from "./TheReleaseStationsCreation.vue?vue&type=template&id=6d3e02e5"
import script from "./TheReleaseStationsCreation.vue?vue&type=script&lang=js"
export * from "./TheReleaseStationsCreation.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__